<template>

  <Sidebar v-model:visible="filtervisible" position="bottom" class="sidebar_filter">
    <template #header>
      <div class="d-flex justify-content-around align-items-center border-bottom">
        <p class="blue-small-txt" @click="closeside()">Cancel</p>
        <div class="text-center">
          <h6 class="">Filter</h6>
          <p class="light-txt">Result 10 of 22</p>
        </div>
        <p class="blue-small-txt" @click="closeside()">Reset</p>
      </div>
    </template>
    <div>
      <slot name="filterslot"></slot>
    </div>
  </Sidebar>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
export default defineComponent({
  props: {
    filtervisible: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const filtervisible = ref(false);
    const closeside = () => {
      emit("closeside");
    }
    return {
      filtervisible,
      closeside
    }
  }
})

</script>